// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Kb6D","notes":"Notes_notes__1dHCu"};